import SpinnerController from '../button_component/spinner_controller'

export default class extends SpinnerController {

}
